import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { setTrackDataLayer, getQueryParams } from '../../../utils/index';
import Dropdown from '../../../components/react/Dropdown';
import Pagination from '../../../components/react/Pagination';
import FacetList from './FacetList';


const ContentTab = ({
  page,
  sort,
  filters,
  tab,
  resultsInfo,
  resultsListing,
  sortOptions,
  currentPage,
  resultsPerPage,
  totalPages,
  facets,
  selectedTab,
  loading,
  setPage,
  setSort,
  setFilters
}) => {
  const handleFilters = filter => {
    const selectedFacets = { ...filters };
    selectedFacets[filter.name] = filter.options;

    setFilters(selectedFacets);
  };

  const handleDataLayer = e => {
    e.preventDefault();
    const href = e.target.closest('a').href;
    if (href) {
      setTrackDataLayer({
        eventName: 'search_bar_navigations',
        custom: {
          search_term: getQueryParams(),
          landing_page: href
        }
      });

      window.location.href = href;
    }
  };

  return (
    <>
      <div
        className={
          tab.value === selectedTab.value
            ? 'search-results__tab-content search-results__tab-content--content active'
            : 'search-results__tab-content search-results__tab-content--content'
        }
        tabIndex={tab.value === selectedTab.value ? 0 : -1}
        role="tabpanel"
        aria-labelledby={tab.label}
      >
        {loading && !resultsListing ? (
          <div className="results-listing__loading"></div>
        ) : (
          <>
            <div className="search-results__info-sort-container">
              <div className="search-results__info-copy">
                {resultsInfo && parse(resultsInfo)}
              </div>
              {!!sortOptions && (
                <div className="search-results__dropdown-container">
                  <Dropdown
                    options={sortOptions}
                    onChange={sort => setSort(sort.value)}
                    selectedOption={
                      sort
                        ? sortOptions.find(opt => {
                          if (opt.value === sort) {
                            return opt.value;
                          } else if (opt.selected) {
                            return opt.value;
                          }
                        })
                        : sortOptions[0]
                    }
                  />
                </div>
              )}
            </div>
            {resultsListing.length > 0 && (
              <div className="search-results__inner-tab-content">
                {facets && (
                  <FacetList
                    facets={facets}
                    selectedFacets={filters}
                    onFiltersChange={handleFilters}
                  />
                )}
                <div className="search-results__container">
                  <div className="search-results__listing">
                    {resultsListing &&
                      resultsListing.map((item, index) => (
                        <div key={index} className="search-results__item">
                          {item.imageUrl && <img src={item.imageUrl} />}
                          <div className="search-results__item-info">
                            <a href={item.link} onClick={e => handleDataLayer(e)}>
                              <h3 className="search-results__item-title">
                                {parse(item.title)}
                              </h3>
                            </a>
                            <div className="search-results__item-copy rtf">
                              {item.copy ? parse(item.copy) : null}
                            </div>
                            {item.contentType ? (
                              <p className="search-results__content-type">
                                {item.contentType}
                              </p>
                            ) : (
                              ''
                            )}
                            {item.categories && item.categories.length ? (
                              <div className="search-results__item-categories">
                                {item.categories.map((category, index) => {
                                  return (
                                    <div key={index}>
                                      <a href={category.link} onClick={e => handleDataLayer(e)}>
                                        {category.name}
                                      </a>
                                      {index !== item.categories.length - 1 ? (
                                        <span> {'>'} </span>
                                      ) : (
                                        ' '
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            ): ''}
                          </div>
                        </div>
                      ))}
                  </div>
                  {!!totalPages && (
                    <Pagination
                      currentPage={page ? Number(page) : Number(currentPage)}
                      totalPages={totalPages && totalPages}
                      onNavigate={setPage}
                      resultsPerPage={resultsPerPage}
                      resultsListing={resultsListing}
                    />
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

ContentTab.propTypes = {
  facets: PropTypes.array,
  subTitle: PropTypes.string,
  resetBtnLabel: PropTypes.string
};

export default ContentTab;
